module.exports = __webpack_public_path__ + "static/media/SCAN_LOCATION.e53eb44b.svg";